// import { Link } from 'react-router-dom';

import React from 'react';


export default function Navbar(props) {
  return (
    <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
   
    <a className="navbar-brand" href="#">{props.title}</a>
    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
  
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav mr-auto">
        { <li className="nav-item active">
         <a className="nav-link" href="#">Home</a>
          {/* <Link className="nav-link" to="/">Home </Link> */}
        </li> }
        {/* <li className="nav-item">
          <Link className="nav-link " to="/about">About</Link>
          
        </li> */}
      </ul>
    </div>

    <div className="form-check form-switch container">
  <input className="form-check-input " onClick={props.toggleMode} type="checkbox"  role='switch' id="flexSwitchCheckDefault" />
</div>
  </nav>
  )
}

